import api from '@/services/api';

const mfaPath = '/auth/mfa';

export interface MfaSetupRequest {
    method: string;
    email?: string;
    phone?: string;
}

export interface MfaSetupResponse {
    method: string;
    message: string;
    qr_code: string;
    secret: string;
}

export interface MfaVerifyRequest {
    token: string;
    method: string;
    remember_device: boolean;
    device_name?: string;
    device_uuid?: string;
}

export interface MfaVerifyResponse {
    verified: boolean;
    recovery_codes?: string[];
}

export interface RegenerateRecoveryCodesRequest {
    method: 'totp' | 'email';
    token: string;
}

export interface RegenerateRecoveryCodesResponse {
    recovery_codes: string[];
}

export interface MfaSendResponse {
    method: string;
}

export const mfa_setup = async (mfa_setup: MfaSetupRequest): Promise<MfaSetupResponse> => {
    const response = await api.post<MfaSetupResponse>(mfaPath + '/setup', mfa_setup);
    return response.data;
};

export const mfa_verify = async (mfa_verify: MfaVerifyRequest): Promise<MfaVerifyResponse> => {
    const response = await api.post<MfaVerifyResponse>(mfaPath + '/verify', mfa_verify);
    return response.data;
};

export const mfa_send = async (): Promise<MfaSendResponse> => {
    const response = await api.post<MfaSendResponse>(mfaPath + '/send');
    return response.data;
};

export const regenerateRecoveryCodes = async (
    payload: RegenerateRecoveryCodesRequest,
): Promise<RegenerateRecoveryCodesResponse> => {
    const response = await api.post<RegenerateRecoveryCodesResponse>(
        mfaPath + '/recovery-codes/regenerate',
        payload,
    );
    return response.data;
};
